// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4242b263","422":"cb843858","667":"706f1720"}[chunkId] + ".chunk.js";
};